import { z } from "zod";
export { LOYALTY_EARN_RULE_KIND_LABELS, LOYALTY_EARN_RULE_KINDS, LOYALTY_RULE_SCOPE_KINDS, LOYALTY_RULE_SCOPE_LABELS, loyaltyEarnRuleKindSchema, loyaltyEarnRuleObjectSchema, loyaltyEarnRuleSchema, loyaltyPointValueSchema, loyaltyRuleScopeKindSchema, subscriptionEntitlementSchema, } from "@station/pricing-engine";
export const LOYALTY_ENTRY_TYPES = ["EARN", "REDEEM", "EXPIRE", "REVERSAL", "RESTORE", "ADJUST"];
export const loyaltyEntryTypeSchema = z.enum(LOYALTY_ENTRY_TYPES);
export const LOYALTY_ENTRY_TYPE_LABELS = {
    EARN: "Kazanım",
    REDEEM: "Harcama",
    EXPIRE: "Süre sonu",
    REVERSAL: "İptal / iade (kazanım geri alındı)",
    RESTORE: "İptal (harcama geri yüklendi)",
    ADJUST: "Düzeltme",
};
export const LOYALTY_ENTRY_STATUSES = ["POSTED", "PENDING_REVIEW", "REJECTED"];
export const loyaltyEntryStatusSchema = z.enum(LOYALTY_ENTRY_STATUSES);
export const LOYALTY_ENTRY_STATUS_LABELS = {
    POSTED: "İşlendi",
    PENDING_REVIEW: "İncelemede (kötüye kullanım şüphesi)",
    REJECTED: "Reddedildi",
};
export const COUPON_ISSUANCES = ["BATCH", "EARNED", "MANUAL"];
export const couponIssuanceSchema = z.enum(COUPON_ISSUANCES);
export const COUPON_ISSUANCE_LABELS = {
    BATCH: "Toplu kod üretimi",
    EARNED: "Kazanım kuponu (koşul sağlanınca)",
    MANUAL: "Elle verilen",
};
export const COUPON_STATUSES = ["ISSUED", "REDEEMED", "EXPIRED", "CANCELLED"];
export const couponStatusSchema = z.enum(COUPON_STATUSES);
export const COUPON_STATUS_LABELS = {
    ISSUED: "Kullanılabilir",
    REDEEMED: "Kullanıldı",
    EXPIRED: "Süresi doldu",
    CANCELLED: "İptal",
};
export const SUBSCRIPTION_STATUSES = ["ACTIVE", "PAUSED", "CANCELLED", "EXPIRED"];
export const subscriptionStatusSchema = z.enum(SUBSCRIPTION_STATUSES);
export const SUBSCRIPTION_STATUS_LABELS = {
    ACTIVE: "Etkin",
    PAUSED: "Duraklatıldı",
    CANCELLED: "İptal",
    EXPIRED: "Süresi doldu",
};
export const SUBSCRIPTION_BILLINGS = ["POS", "INVOICE"];
export const subscriptionBillingSchema = z.enum(SUBSCRIPTION_BILLINGS);
//# sourceMappingURL=enums.js.map